module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mainbox_border"
  }, [_c('section', {
    staticClass: "m0 cb pt15",
    style: ({
      minHeight: _vm.minHeight + 'px'
    })
  }, [_c('article', {
    staticClass: "rightMenu oh"
  }, [_c('router-view')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-9bddd008"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/PersonalMain.vue
// module id = 1170
// module chunks = 41